export const SECTION_NAME = "Vendor";

export const INTRO_TEXT = ``;

export const EXAMPLE_JSON = `{
    "id": 123,
    "starred": 0,
    "syncToken": 0,
    "name": "ABC Plastics",
    "email": "mike@abcplastics.com",
    "website": "https://abc.com",
    "phone": "817-555-1212",
    "mobile": "817-555-2121",
    "altPhone": null,
    "fax": null,
    "companyName": "Good Supplier, Inc.",
    "contact" {
      "title": "Ms",
      "firstName": "Diane",
      "lastName": "Allen",
      "suffix": null
    },
    "address": {
      "line1": "123 Main St",
      "line2": null,
      "line3": null,
      "line4": null,
      "line5": null,
      "city": "Syracuse",
      "stateProvince": "NY",
      "postalCode": "13202",
      "country": "US"
    },
    "terms": {
      "id": 11,
      "name": "NET 30"
    },
    "accountNumber": "87-3049"
    "currency": {
      "id": 42,
      "name": "USD"
    },
    "taxCode": {
      "id": 5,
      "name": "Sales Tax"
    }
    "showOnForms": true,    
    "notes": null,
    "archived": false,
    "summaryOnly": false,
    "lastSync": "2019-10-22T00:00:00",
    "syncMessage": "",
    "customFields": [
      {
        "id": 5,
        "name": "Checkbox",
        "value": "false",
        "dataType": "Boolean"
      },
      {
        "id": 13,
        "name": "Cust-Acct-No",
        "value": null,
        "dataType": "Number"
      }
    ],
    "altAddresses": [],
  }`;

export const ATTRIBUTES = [
  {
    name: "id",
    type: "integer",
    description:
      "Unique identifier for this record. Must not be provided when creating a customer.",
  },
  {
    name: "starred",
    type: "integer",
    description: `Indicates if this vendor has been starred. A value of 0 = no star; 1 or 1-3 = starred. Star colors 
      depend on application configuration. This could be 1 color of star or 3 colors of star. See 
      company setting in the user guide for more details.`,
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record. If you receive an error when updating a record, it is because your syncToken is for an older version of the record than that which is currently in the database. Please GET the latest version prior to updating.`,
  },
  {
    name: "name",
    type: "string",
    description: `The name by which you look up this vendor.`,
  },
  {
    name: "email",
    type: "string",
    description: `Vendor email address.`,
  },
  {
    name: "website",
    type: "string",
    description: `Include the entire address, like "http://www.acompany.com".`,
  },
  {
    name: "phone",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "mobile",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "altPhone",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "fax",
    type: "string",
    description: `Self-explanatory. No format is enforced.`,
  },
  {
    name: "companyName",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "contact",
    type: "contact",
    description: `The person to contact regarding this vendor.`,
  },
  {
    name: "address",
    type: "company address",
    description: `The vendor's billing address.`,
  },
  {
    name: "terms",
    type: "reference",
    description: `Payment terms.`,
  },
  {
    name: "accountNumber",
    type: "string",
    description: `Self-explanatory.`,
  },
  {
    name: "currency",
    type: "reference",
    description: `Currency used for vendor, if multicurrency is enabled.`,
  },
  {
    name: "taxCode",
    type: "reference",
    description: `Tax type for this vendor.`,
  },
  {
    name: "showOnForms",
    type: "boolean",
    description: `True if vendor appears in dropdown lists on purchasing forms. False, if not.`,
  },
  {
    name: "notes",
    type: "string",
    description:
      "The company’s internal notes about this vendor. These notes are not visible to the vendor.”",
  },
  {
    name: "archived",
    type: "boolean",
    description: `True if item is archived, false if not.`,
    readOnly: true,
  },
  {
    name: "summaryOnly",
    type: "boolean",
    description: `Indicates if the summary parameter was set when retrieving back this record`,
    readOnly: true,
  },
  {
    name: "lastSync",
    type: "date",
    newField: "New October 2nd",
    description: `The last successful sync time (GMT) for this vendor, if syncronizing with Quickbooks.`,
    readOnly: true,
  },
  {
    name: "syncMessage",
    type: "string",
    newField: "New October 2nd",
    description: `The sync error message if the last sync attempt failed with Quickbooks. This will be empty if synchronization is successful.`,
    readOnly: true,
  },
  {
    name: "customFields",
    type: "array of custom fields",
    description: `The list of custom fields for this object type.`,
  },
  {
    name: "altAddresses",
    type: "array of vendor addresses",
    description: `See the address field for address format.`,
  },
];

export const LINE_ITEM = [];

export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
     The API limits results to a max of 200 results per call.  If you want to retrieve the next set
      of results you can use this parameter to retrive the next set of results.  For example if you
       are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`,
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`,
  },
  {
    name: "summary",
    type: "",
    description: `If this parameter is included on the the query, summary records will be returned that do not populate every field.`,
  },
  {
    name: "query",
    type: "string",
    description: `This parameter will filter the results by matches of the string on the following fields: name or notes.`,
  },
  {
    name: "archived",
    type: "string: yes/no",
    description: `A "yes" returns archived records only; a "no" returns only those that have not been archived.`,
  },
  {
    name: "createdsince/updatedsince",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS ",
    description: `Filters transactions created or updated since a specified date/time.`,
  },
];

export const SAMPLE_QUERY_REQUEST =
  "/api/v2/vendor?start=101&maxresults=100&summary=yes&archived=no&createdsince=2019-09-10T00:00:00&updatedsince=2019-09-10T23:59:59";
